import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import {
  ScenarioName,
  useOnboardingGetProcessByScenarioName,
} from 'api/requests';
import {
  useLegalClientBeneficiarySettingsSave,
  useLegalClientCompleteBeneficiaryOnboarding,
  useLegalClientGetBeneficiaryLazy,
} from 'api/requests/onboarding/legal/beneficiary';
import {
  LegalClientEntity,
  LegalClientRepresentativeEntity,
  OnboardingProcessStepNameType,
} from 'api/types/entity';

export const useOnboarding = (
  currentClient: LegalClientRepresentativeEntity,
  legalClient: LegalClientEntity,
  legalClientBeneficiaryId?: string
) => {
  const beneficiaryId = useRef(legalClientBeneficiaryId);
  const [loading, setLoading] = useState(false);

  const { saveSettings } = useLegalClientBeneficiarySettingsSave();

  const { getBeneficiary, legalClientBeneficiary } =
    useLegalClientGetBeneficiaryLazy();

  const { process, loading: processLoading } =
    useOnboardingGetProcessByScenarioName(ScenarioName.LegalClientBeneficiary);

  const { complete } = useLegalClientCompleteBeneficiaryOnboarding();

  const onGoBack = useCallback(
    async (name: OnboardingProcessStepNameType) => {
      if (legalClientBeneficiaryId) {
        await saveSettings(legalClient.id, legalClientBeneficiaryId, name);
      }
    },
    [legalClient.id, legalClientBeneficiaryId, saveSettings]
  );

  useLayoutEffect(() => {
    if (beneficiaryId.current) {
      setLoading(true);
      getBeneficiary(legalClient.id, beneficiaryId.current).finally(() =>
        setLoading(false)
      );
    }
  }, [getBeneficiary, legalClient.id]);

  const onComplete = async () =>
    complete(legalClient.id, legalClientBeneficiaryId!);

  return {
    currentClient,
    legalClientBeneficiary,
    legalClient,
    loading: loading || (processLoading && !process),
    process,
    getBeneficiary,
    onGoBack,
    onComplete,
  };
};
